import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowBack } from '@mui/icons-material'
import { Box, Button, ButtonBase, Dialog, DialogContent, Grid, Stack, Typography } from '@mui/material'

import GRDialogTitle from '../../../../../components/GRDialogTitle/GRDialogTitle'
import { borderRadiusDefault } from '../../../../../themes/theme'
import { GameAnalysisScreenshot } from '../../types/GameAnalyses'

type AnalysisScreenshotsDialogProps = {
  open: boolean
  gameName: string
  gameVersion?: string | null
  screenshots: GameAnalysisScreenshot[]
  onClose: () => void
}

export const AnalysisScreenshotsDialog: FC<AnalysisScreenshotsDialogProps> = ({ open, gameName, gameVersion, screenshots, onClose }) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState<GameAnalysisScreenshot>()

  useEffect(() => {
    if (!open) setSelected(undefined)
  }, [open])

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <GRDialogTitle onClose={onClose}>
        <Box minWidth={0}>
          {t('internal-analysts:games_analyses_screenshots_title', { name: gameName })}
          {gameVersion && (
            <Typography variant="body2" color="text.secondary">
              {t('internal-analysts:games_analyses_changed_features_version', { version: gameVersion })}
            </Typography>
          )}
        </Box>
      </GRDialogTitle>
      <DialogContent>
        {selected ? (
          <Stack spacing={2} alignItems="center">
            <Box component="img" src={selected.url} alt={selected.screenshotId} sx={{ maxWidth: '100%', maxHeight: '70vh' }} />
            <Button startIcon={<ArrowBack />} onClick={() => setSelected(undefined)}>
              {t('internal-analysts:games_analyses_screenshot_back')}
            </Button>
          </Stack>
        ) : (
          <Grid container spacing={2}>
            {screenshots.map((screenshot, index) => (
              <Grid item xs={6} sm={4} md={3} key={screenshot.screenshotId}>
                <ButtonBase
                  aria-label={t('internal-analysts:games_analyses_screenshot', { index: index + 1 })}
                  onClick={() => setSelected(screenshot)}
                  sx={{ width: '100%', borderRadius: borderRadiusDefault, overflow: 'hidden' }}
                >
                  <Box component="img" src={screenshot.url} alt="" loading="lazy" sx={{ width: '100%', display: 'block' }} />
                </ButtonBase>
              </Grid>
            ))}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  )
}
